import React from 'react';

import { ds } from '@/components/lib/design.system';
import { withOpacity } from '@/styles/styles';

import { PaymentTag } from './PaymentTag';

export const PreferredTag = () => {
    return (
        <PaymentTag
            translationKey="preferred"
            color={ds.colorToken.text.accent.blue}
            backgroundColor={withOpacity(ds.colorValue.background.accent.blue.strong, 0.16)}
        />
    );
};
